import ReactMarkdown from "react-markdown";

export default ReactMarkdown;
